import { render, staticRenderFns } from "./DetailPO-Bottom.vue?vue&type=template&id=6d1eaa4c&"
import script from "./DetailPO-Bottom.vue?vue&type=script&lang=js&"
export * from "./DetailPO-Bottom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports